import React, { Component } from "react";
import "antd/dist/antd.css";
import { Form, Input, Button, Icon } from "antd";
import { Row, Col, Select } from "antd";
import { Link } from "react-router-dom";
import Uploaded from "../../Images/uploaded.png";
import Uploadlisting from "../../Images/uploadlisting.png";
import {
  updateCustomerOrCarrierDetails,
  getCustomerOrCarrierDetails,
} from "../../api/OraganizationApis";
import { noWhitespaceRule } from "../../utils/Utils";

let id = 0;
const { Option } = Select;

class Truck extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
    };
  }
  remove = (k) => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    if (keys.length === 0) {
      return;
    }
    form.setFieldsValue({
      keys: keys.filter((key) => key !== k),
    });
  };
  add = () => {
    const { form } = this.props;
    const keys = form.getFieldValue("keys");
    const nextKeys = keys.concat(id++);
    form.setFieldsValue({
      keys: nextKeys,
    });
  };
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const { keys } = values;
        let truckData = [];
        this.setState({
          loading: true,
        });
        // this.props.history.push('/carrier_app/review');
        truckData.push({
          typeOfTruck: values["typeOfTruck"],
          truckNumber: values["truckNumber"],
        });
        keys.map((key) => {
          return truckData.push({
            typeOfTruck: values[key + "_typeOfTruck"],
            truckNumber: values[key + "_truckNumber"],
          });
        });
        let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
        let data = {
          entityData: {
            carrierFiles: {
              documents: orgDetails["carrierFiles"]["documents"],
              trucks: truckData,
            },
          },
        };
        updateCustomerOrCarrierDetails(orgDetails["id"], data).then(
          (result) => {
            if (result.success) {
              getCustomerOrCarrierDetails(orgDetails["id"]).then((result) => {
                if (result.success) {
                  localStorage.setItem(
                    "orgDetails",
                    JSON.stringify(result.data)
                  );
                  // this.props.history.push('/carrier_app/orders');
                  this.props.history.push("/carrier_app/review");
                }
              });
            } else {
              console.log(result.errors);
            }
          }
        );
      }
    });
  };
  render() {
    const { getFieldDecorator, getFieldValue } = this.props.form;
    // const formItemLayout = {
    //   labelCol: {
    //     xs: { span: 24 },
    //     sm: { span: 4 },
    //     lar: {span:24},
    //   },
    //   wrapperCol: {
    //     xs: { span: 24 },
    //     sm: { span: 20 },
    //     lar: {span:24},
    //   },
    // };
    const formItemLayoutWithOutLabel = {
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 24 },
      },
    };
    getFieldDecorator("keys", { initialValue: [] });
    const keys = getFieldValue("keys");
    const formItems = keys.map((k, index) => (
      <Row
        style={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
        }}
      >
        <Col span={11}>
          <Form.Item
            label={<span style={{ color: "#7B8190" }}>Type of Truck</span>}
            required={false}
            key={k}
          >
            {getFieldDecorator(k + "_typeOfTruck", {
              validateTrigger: ["onChange", "onBlur"],
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: "Please input Type of Truck or delete this field.",
                },
              ],
            })(
              <Select
                notFoundContent={"Not found?!"}
                placeholder="Delivery Truck"
                // onChange={(value) => this.setState({ deliveryTruck: value })}
                style={{ width: "95%" }}
              >
                <Option value="Tractor Trailer">Tractor Trailer</Option>
                <Option value="Dump Truck/Triaxle">Dump Truck/Triaxle</Option>
                <Option value="Mason Dump">Mason Dump</Option>
                <Option value="Flatbed with forklift">
                  Flatbed with forklift
                </Option>
                <Option value="Flatbed">Flatbed</Option>
              </Select>
            )}
          </Form.Item>
        </Col>
        <Col span={11}>
          <Form.Item
            label={<span style={{ color: "#7B8190" }}>Type of Truck</span>}
            required={false}
            key={k}
          >
            {getFieldDecorator(k + "_truckNumber", {
              validateTrigger: ["onChange", "onBlur"],
              rules: [
                {
                  required: true,
                  whitespace: true,
                  message: "Please, input Truck Number or delete this field.",
                },
              ],
            })(<Input placeholder="Truck Number" style={{ width: "95%" }} />)}
          </Form.Item>
          {/* <Form.Item label = {<span style={{color:'#7B8190'}}>Truck Number</span>} >
        {getFieldDecorator('Ty', {
                      rules: [{  message: 'Please input Truck number or delete this field.' }],
                      })
                      (<Input />)}
                    </Form.Item> */}
        </Col>
        <Col span={2} style={{ marginTop: "auto", marginBottom: "auto" }}>
          {keys.length > 0 ? (
            <Icon
              className="dynamic-delete-button"
              type="minus-circle-o"
              title="remove"
              onClick={() => this.remove(k)}
            />
          ) : null}
        </Col>
      </Row>
    ));
    return (
      <div>
        <div className="Docdiv">
          <h3
            className="Docheading"
            style={{ fontSize: "30px", lineHeight: "30px" }}
          >
            Trucks
          </h3>
          <p className="Docpara" style={{ fontSize: "17px", color: "#7B8190" }}>
            Please, upload truck numbers ( optional )
          </p>
          <Row type="flex" justify="start">
            <Col xs={24} sm={24} md={6} lg={6} className="DocumentsCol">
              <div className="DocumentDivUnselect">
                <img src={Uploaded} className="Circle" alt="Upload icon" />
                <h3>Documents</h3>
              </div>
              <div className="DocumentDivSelect">
                <img src={Uploadlisting} className="Circle" alt="Upload icon" />
                <h3>Trucks</h3>
              </div>
            </Col>
            <Col
              xs={24}
              sm={24}
              md={17}
              lg={17}
              style={{
                backgroundColor: "white",
                minHeight: "400px",
                borderRadius: "10px",
                padding: "40px",
              }}
              className="trucks-documentation-section"
            >
              <div>
                <h3>Trucks</h3>
                <p style={{ fontSize: "17px", color: "#7B8190" }}>
                  You can skip this step and add truck number later
                </p>
                <p style={{ fontSize: "20px", color: "#7B8190" }}>
                  I'm uploading:
                </p>
                <div>
                  <Form onSubmit={this.handleSubmit}>
                    <Row gutter={10}>
                      <Col xs={24} sm={24} md={11} lg={11}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Type of Truck
                            </span>
                          }
                        >
                          {getFieldDecorator("typeOfTruck", {
                            rules: [
                              { message: "Please input your Type of Truck" },
                            ],
                          })(
                            <Select
                              notFoundContent={"Not found?!"}
                              placeholder="Delivery Truck"
                              // onChange={(value) => this.setState({ deliveryTruck: value })}
                              style={{ width: "100%" }}
                            >
                              <Option value="Tractor Trailer">
                                Tractor Trailer
                              </Option>
                              <Option value="Dump Truck/Triaxle">
                                Dump Truck/Triaxle
                              </Option>
                              <Option value="Mason Dump">Mason Dump</Option>
                              <Option value="Flatbed with forklift">
                                Flatbed with forklift
                              </Option>
                              <Option value="Flatbed">Flatbed</Option>
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col span={11}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Truck number
                            </span>
                          }
                        >
                          {getFieldDecorator("truckNumber", {
                            rules: [
                              { message: "Please input your Truck Number" },
                              noWhitespaceRule,
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                    </Row>
                    {formItems}
                    <Form.Item {...formItemLayoutWithOutLabel}>
                      <Button
                        type="dashed"
                        onClick={this.add}
                        style={{
                          textAlign: "center",
                          backgroundColor: "#0E4D90",
                          width: "20px",
                          borderRadius: "50%",
                          borderColor: "#0E4D90",
                          padding: "0px",
                          height: "20px",
                        }}
                      >
                        <Icon
                          type="plus"
                          style={{
                            verticalAlign: "0px",
                            fontSize: "14px",
                            color: "white",
                          }}
                        />
                      </Button>
                      <span
                        style={{
                          marginLeft: "7px",
                          color: "#0E4D90",
                          lineHeight: "20px",
                        }}
                      >
                        Add Truck
                      </span>
                    </Form.Item>
                    <Form.Item
                      {...formItemLayoutWithOutLabel}
                      style={{ textAlign: "center", marginTop: "2%" }}
                    >
                      <Link
                        to="/carrier_app/review"
                        style={{ color: "#FF6C5E", marginRight: "30px" }}
                      >
                        Skip this step
                      </Link>
                      <Button
                        type="primary"
                        htmlType="submit"
                        className="truckSubmit"
                        loading={this.state.loading}
                        disabled={
                          this.props.form.getFieldValue("truckNumber") &&
                          this.props.form.getFieldValue("typeOfTruck")
                            ? false
                            : true
                        }
                      >
                        Submit
                      </Button>
                    </Form.Item>
                  </Form>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    );
  }
}
export default Form.create({ name: "truck" })(Truck);
